"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateSchema = void 0;
exports.DateSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/date.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "Date",
    "description": "Store a date",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:date"
            ]
        },
        "date": {
            "type": "string",
            "pattern": "^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$"
        }
    },
    "required": [
        "date",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0ZS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbW9kdWxlcy9hdHRyaWJ1dGVzL2RhdGUuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsVUFBVSxHQUFHO0lBQ3hCLEtBQUssRUFBRSw2REFBNkQ7SUFDcEUsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsTUFBTTtJQUNmLGFBQWEsRUFBRSxjQUFjO0lBQzdCLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLHNCQUFzQixFQUFFLEtBQUs7SUFDN0IsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFO2dCQUNOLGlCQUFpQjthQUNsQjtTQUNGO1FBQ0QsTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsU0FBUyxFQUFFLHVEQUF1RDtTQUNuRTtLQUNGO0lBQ0QsVUFBVSxFQUFFO1FBQ1YsTUFBTTtRQUNOLE1BQU07S0FDUDtDQUNGLENBQUEifQ==